// src/components/theme-toggle.ts

import { LitElement, html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { themeService, ThemeType } from './theme-service';

@customElement('theme-toggle')
export class ThemeToggle extends LitElement {
  static styles = css`
    .theme-toggle {
      display: flex;
      align-items: center;
      cursor: pointer;
      user-select: none;
      padding: 4px 8px;
      border-radius: 4px;
      transition: background-color 0.2s;
    }

    .theme-toggle:hover {
      background-color: var(--lumo-contrast-10pct);
    }

    .theme-icon {
      margin-right: 8px;
      font-size: 20px;
      display: flex;
      align-items: center;
    }

    .material-icons {
      font-family: 'Material Icons';
      font-size: 16px;
    }
  `;

  @state() private currentTheme: ThemeType = 'light';

  connectedCallback() {
    super.connectedCallback();
    themeService.addThemeChangeListener(this.handleThemeChange);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    themeService.removeThemeChangeListener(this.handleThemeChange);
  }

  private handleThemeChange = (theme: ThemeType) => {
    this.currentTheme = theme;
    this.requestUpdate();
  };

  private toggleTheme() {
    themeService.toggleTheme();
  }

  render() {
    return html`
      <div class="theme-toggle" @click=${this.toggleTheme}>
        <span
          >${this.currentTheme === 'light' ? 'Dark Mode' : 'Light Mode'}</span
        >
        <span class="theme-icon material-icons">
          ${this.currentTheme === 'light' ? 'dark_mode' : 'light_mode'}
        </span>
      </div>
    `;
  }
}
